// Duplicated from app-domain/TemplateAdmin :| but with personalFirst modifier
// XXX: move to some lib
// TODO: migrate to @gandi/resource
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsFailureOrganizations, selectIsFetchingOrganizations, selectIsLoadedOrganizations, selectOrganizationsList, organizationsResource, computeOrganizationsLabel, fetchOrganizationsList } from '@gandi/redux-organization';
import { selectPersonalId } from '@gandi/redux-sharing';
export const eventuallyFetchList = fetchProps => (dispatch, getState) => {
  const label = computeOrganizationsLabel(fetchProps);
  const shouldFetch = organizationsResource.selectShouldFetch(getState(), {
    label
  });
  if (shouldFetch) {
    return dispatch(fetchOrganizationsList(fetchProps));
  }
  return undefined;
};
export const useOrganizationList = ({
  fetchProps,
  personalFirst = false
}) => {
  const dispatch = useDispatch();
  const label = computeOrganizationsLabel(fetchProps);
  const shouldFetch = useSelector(state => organizationsResource.selectShouldFetch(state, {
    label
  }));
  React.useEffect(() => {
    if (shouldFetch) {
      dispatch(eventuallyFetchList(fetchProps));
    }
  }, [dispatch, fetchProps, shouldFetch]);
  const personalOrgId = useSelector(selectPersonalId);
  const rawOrga = useSelector(state => selectOrganizationsList(state, fetchProps));
  const organizations = React.useMemo(() => {
    const orga = [...rawOrga];
    orga.sort((a, b) => {
      // Always display personal organization on top of the list
      if (personalFirst && a.id === personalOrgId) {
        return -1;
      }
      if (personalFirst && b.id === personalOrgId) {
        return 1;
      }
      const aName = a.name.toUpperCase();
      const bName = b.name.toUpperCase();
      return aName < bName ? -1 : 1;
    });
    return orga;
  }, [rawOrga, personalOrgId, personalFirst]);
  const isFailure = useSelector(state => selectIsFailureOrganizations(state, fetchProps));
  const isFetching = useSelector(state => selectIsFetchingOrganizations(state, fetchProps));
  const isLoaded = useSelector(state => selectIsLoadedOrganizations(state, fetchProps));
  return {
    organizations,
    isFailure,
    isFetching,
    isLoaded
  };
};
useOrganizationList.preFetch = ({
  dispatch,
  fetchProps
}) => dispatch(eventuallyFetchList(fetchProps));